import { IDescriptionQuality, TDescriptionQualityField } from '../model/types'

type TDescriptionQualityValue = TDescriptionQualityField | null | undefined

export const isDescriptionQuality = (
  value: TDescriptionQualityValue
): value is IDescriptionQuality => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'Score' in value &&
    typeof value.Score === 'number' &&
    'Reasons' in value &&
    Array.isArray(value.Reasons) &&
    value.Reasons.every((reason) => typeof reason === 'string')
  )
}

export const parseDescriptionQuality = (
  value: TDescriptionQualityValue
): IDescriptionQuality | null => {
  if (!value) {
    return null
  }

  let parsed: TDescriptionQualityValue = value

  for (let parseAttempt = 0; parseAttempt < 2; parseAttempt += 1) {
    if (isDescriptionQuality(parsed)) {
      return parsed
    }

    if (typeof parsed !== 'string' || !parsed.trim()) {
      return null
    }

    try {
      parsed = JSON.parse(parsed) as TDescriptionQualityField
    } catch {
      return null
    }
  }

  return isDescriptionQuality(parsed) ? parsed : null
}
